/** Panel Design System — primitive hex palette (light-mode source for CSS vars) */

export const PANEL_PRIMITIVE = {
  white: "#ffffff",
  slate50: "#f8fafc",
  slate100: "#f1f5f9",
  slate200: "#e2e8f0",
  slate300: "#cbd5e1",
  slate300Alt: "#dbe3ee",
  slate400: "#94a3b8",
  slate500: "#64748b",
  slate600: "#475569",
  slate700: "#334155",
  slate800: "#1e293b",
  slate900: "#0f172a",
  tealAccent: "#4CCEAC",
  tealAccentHover: "#3DBE9C",
  tealText: "#0f766e",
  tealFocus: "#0f9b7c",
  blue500: "#3b82f6",
  blue600: "#1d4ed8",
  blue100: "#dbeafe",
  emerald600: "#059669",
  red600: "#dc2626",
  formGradientEnd: "#5d9fff",
  indigoSoftBg: "rgba(99, 102, 241, 0.18)",
  indigo400: "#818cf8",
  indigo500: "#4F46E5",
  indigoHover: "#4338ca",
  indigoText: "#312e81",
};
